<div class="loan-status-card">
  <span class="loan-status-card__label">Loan Status</span>
  <h3 class="loan-status-card__value m-0" [title]="loanStatusName">{{ loanStatusName }}</h3>
  @if (subStatusName) {
    <span class="loan-status-card__sub" [title]="subStatusName">{{ subStatusName }}</span>
  }
</div>
